import * as React from 'react';
import { lazy, Suspense } from 'react';
import Breadcrumb from 'src/react/components/breadcrumbs/containers/Breadcrumb';
import app from 'srcJs/App';
import { PAYMENT_HISTORY_URL } from 'modulePaymentIndexHistory/constants';
import { USER_PROFILE_MAIN_URL } from 'moduleUserMain/constants';
import { USER_PROFILE_CHANGE_PASSWORD_URL } from 'moduleUserChangePassword/constants';
import { USER_PROFILE_REFERRAL_URL } from 'moduleUserReferral/constants';
import { USER_PROFILE_REVIEW_URL } from 'moduleUserReview/constants';
import { USER_PROFILE_DEALS_SETTINGS_URL } from 'moduleDealsSettings/constants';
import { Switch } from 'components/router/Switch';
import { Route } from 'components/router/Route';
import { Redirect } from 'components/router/Redirect';
import { USER_PROFILE_API_PAGE_URL, USER_PROFILE_NOTIFICATION } from 'moduleUser/modules/api-page/constants';
import { USER_PUBLIC_PROFILE_URL } from 'modules/user/modules/public-profile/constants';
import { PAYMENT_INVOICES_URL } from 'modulePaymentIndexInvoices/constants';
var ChannelModule = /*#__PURE__*/lazy(function () {
  return import('modules/channel/modules/index/containers/ChannelModule');
});
var ProjectModule = /*#__PURE__*/lazy(function () {
  return import('modules/project/modules/index/containers/ProjectModule');
});
var CatalogChannelList = /*#__PURE__*/lazy(function () {
  return import('moduleCatalogChannelList/containers/List');
});
var MyListsList = /*#__PURE__*/lazy(function () {
  return import('modules/lists/modules/list/containers/MyListsList');
});
var MyListView = /*#__PURE__*/lazy(function () {
  return import('moduleLists/modules/view/containers/MyListView');
});
var Chat = /*#__PURE__*/lazy(function () {
  return import('moduleChatIndex/containers/Chat');
});
var Cart = /*#__PURE__*/lazy(function () {
  return import('moduleCart/containers/Cart');
});
var CartComplete = /*#__PURE__*/lazy(function () {
  return import('moduleCartComplete/containers/CartComplete');
});
var Profile = /*#__PURE__*/lazy(function () {
  return import('moduleUserProfile/containers/Profile');
});
var PaymentIndex = /*#__PURE__*/lazy(function () {
  return import('modulePaymentIndex/containers/Index');
});
var ChannelCreateReview = /*#__PURE__*/lazy(function () {
  return import('modules/review/modules/channel/modules/add/containers/ChannelCreateReview');
});
var CustomerCreateReview = /*#__PURE__*/lazy(function () {
  return import('moduleReviewCustomer/modules/add/containers/CustomerCreateReview');
});
var ReviewCreateOnReject = /*#__PURE__*/lazy(function () {
  return import('moduleReviewCreateOnReject/containers/ReviewCreateOnReject');
});
var PublicProfile = /*#__PURE__*/lazy(function () {
  return import('moduleUserPublicProfile/containers/PublicProfile');
});

var AppRoutes = function AppRoutes() {
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/",
    render: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Breadcrumb, {
        title: app.tForReact('base', 'Main'),
        url: "/"
      }), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
        path: "/",
        exact: true,
        render: function render() {
          var user = app.getUser().getData();

          if (user.isCustomer) {
            return /*#__PURE__*/React.createElement(Redirect, {
              to: "/project/list"
            });
          }

          if (user.isOwner) {
            return /*#__PURE__*/React.createElement(Redirect, {
              to: "/channel/list"
            });
          }

          window.location.href = '/';
          return null;
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: [PAYMENT_HISTORY_URL, PAYMENT_INVOICES_URL],
        render: function render() {
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(PaymentIndex, null));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: [USER_PROFILE_MAIN_URL, USER_PROFILE_CHANGE_PASSWORD_URL, USER_PROFILE_REFERRAL_URL, USER_PROFILE_REVIEW_URL, USER_PROFILE_DEALS_SETTINGS_URL, USER_PROFILE_API_PAGE_URL, USER_PROFILE_NOTIFICATION],
        render: function render() {
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(Profile, null));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: USER_PUBLIC_PROFILE_URL,
        render: function render(_ref) {
          var match = _ref.match;
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(PublicProfile, {
            id: Number(match.params.id),
            type: match.params.type
          }));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/cart",
        exact: true,
        render: function render() {
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(Cart, null));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/cart/complete",
        render: function render() {
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(CartComplete, null));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/chat/:id?",
        render: function render(_ref2) {
          var match = _ref2.match;
          var id = match.params.id;
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(Chat, {
            id: id ? Number(id) : null
          }));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/lists/recommended",
        render: function render() {
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(MyListsList, {
            isRecommended: true
          }));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/lists",
        render: function render() {
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(MyListsList, null));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/list/view/:id",
        render: function render(_ref3) {
          var match = _ref3.match;
          var id = match.params.id;
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(MyListView, {
            id: id,
            key: id,
            path: match.path
          }));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/catalog/channel/list",
        render: function render(_ref4) {
          var match = _ref4.match;
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(CatalogChannelList, {
            path: match.path
          }));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/project",
        render: function render() {
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(ProjectModule, null));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/channel",
        render: function render() {
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(ChannelModule, null));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/review/channel/:channelId/deal/:dealId/add",
        render: function render(_ref5) {
          var match = _ref5.match;
          var _match$params = match.params,
              channelId = _match$params.channelId,
              dealId = _match$params.dealId;
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(ChannelCreateReview, {
            channelId: Number(channelId),
            dealId: Number(dealId)
          }));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/review/customer/:customerId/deal/:dealId/add",
        render: function render(_ref6) {
          var match = _ref6.match;
          var _match$params2 = match.params,
              customerId = _match$params2.customerId,
              dealId = _match$params2.dealId;
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(CustomerCreateReview, {
            customerId: Number(customerId),
            dealId: Number(dealId)
          }));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/review/channel/create-on-reject/:dealId",
        render: function render(_ref7) {
          var match = _ref7.match;
          var dealId = match.params.dealId;
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(ReviewCreateOnReject, {
            dealId: Number(dealId)
          }));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/ui",
        render: function render() {
          var Ui = /*#__PURE__*/lazy(function () {
            return import('modules/templates/ui/Ui');
          });
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: ""
          }, /*#__PURE__*/React.createElement(Ui, null));
        }
      }), /*#__PURE__*/React.createElement(Route, {
        render: function render() {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Breadcrumb, {
            title: "404"
          }), "404");
        }
      })));
    }
  }));
};

export default AppRoutes;